import React from 'react';
import {Button, Container} from "react-bootstrap";
import {useNavigate} from "react-router-dom";

const OrderSuccess = () => {
    const navigate = useNavigate();
    return (
        <Container>
            <p>Ваш заказ создан</p>
            <p>Вы можете отслеживать статус заказа через главную страницу приложения</p>
            <Button onClick={()=>navigate('/')}>Закрыть</Button>
        </Container>
    );
};

export default OrderSuccess;